import { endpoint } from "@/api";
import { DataTable } from "@/components";
import appConfig from "@/config/appConfig";
import { userRole } from "@/constant";
import { flare } from "@flareapp/js";

import { Select, Spin } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { FiEye } from "react-icons/fi";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import AlarmTimeFilter from "./AlarmTimeFilter";
import DashboardCount from "./DashboardCount";
import MapMarker from "./MapMarker";

const MainDashboard = ({ isFullScreenActive }) => {
  const navigate = useNavigate();
  const { userDetails, business } = useSelector((state) => state.user || {});
  const firstBusiness = userDetails?.business?.[0] || {};

  const [mapCenter, setMapCenter] = useState([3.996136, 108.886251]);
  const [dashboardCounter, setDashboardCounter] = useState({});
  const [alarmCounter, setAlarmCounter] = useState({
    totalAcknoledged: 0,
    totalAlram: 0,
    totalTriggeredAlarm: 0,
  });
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [siteLocationsWithSensor, setSiteLocationsWithSensor] = useState([]);
  const [siteLocations, setSiteLocations] = useState([]);
  const [isCounterLoading, setIsCounterLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [markerLoading, setMarkerLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [locations, setLocations] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [markerData, setMarkerData] = useState({
    totalDevices: 0,
    activeSensors: 0,
    inactiveSensors: 0,
  });

  const getSiteLocations = async () => {
    try {
      const response = await axios.get(`/site-location/my-site`, {
        withCredentials: true,
        params: {
          business: business,
          limit: 1000,
        },
      });
      if (response) {
        const data = response.data;
        if (Array.isArray(data)) {
          setSiteLocations(data);
          const firstData = data?.find((data) => data?.latitude && data?.longitude);
          if (firstData?.latitude && firstData?.longitude) setMapCenter([firstData?.latitude, firstData?.longitude]);
        }
        setSiteLocationsWithSensor([]);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  const getSiteLocationsWithSensor = async (search) => {
    try {
      // if (search) {
      setIsLoading(true);
      const response = await axios.get(`/site-location/sensorDetail?page=${page}&limit=${limit}&search=${search}`, {
        withCredentials: true,
        params: { business },
      });
      if (response?.data?.results) {
        setSiteLocationsWithSensor(response.data.results);
        if (response.data.results?.length) {
          let firstData = response.data.results[0];
          if (firstData) {
            if (firstData?.latitude && firstData?.longitude) setMapCenter([firstData?.latitude, firstData?.longitude]);
          }
        }
        setTotal(response.data.total);
      }
      // }
      setIsLoading(false);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };
  const getSensorDetails = async (id) => {
    try {
      setMarkerLoading(true);
      const response = await axios.get(`/device/getSensorDetails/${id}`, {
        withCredentials: true,
      });
      if (response.status === 200) {
        setMarkerData(response.data);
      }
      setMarkerLoading(false);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  const handleMarkerClick = (id) => {
    getSensorDetails(id);
  };
  const searchHandler = (e) => {
    e.preventDefault();
    setPage(1);
    if (search) {
      setLocations("");
      getSiteLocationsWithSensor(search);
    } else if (locations) {
      setSearch("");
      getSiteLocationsWithSensor(locations);
    } else {
      getSiteLocations();
    }
  };

  const columns = [
    {
      title: "No.",
      render: (row, _, ind) => ind + 1,
      width: "60px",
      align: "center",
    },
    {
      title: "Location",
      render: (row) => <p className="m-0">{row?.name || "--"}</p>,
    },
    {
      title: "Total Sensor",
      render: (row) => <p className="m-0">{row?.totalDevices || 0}</p>,
      align: "center",
    },
    {
      title: "Sensor Online",
      render: (row) => <p className="m-0">{row?.activeSensors || 0}</p>,
      align: "center",
    },
    {
      title: "Sensors Offline",
      render: (row) => <p className="m-0">{row?.inactiveSensors || 0}</p>,
      align: "center",
    },
    {
      title: "Action",
      width: "60px",
      align: "center",
      render: (row) => (
        <div>
          <Button
            variant="success"
            // disabled={!row?.dashboard}
            onClick={() => {
              // dispatch(setActiveDashboard(row?.dashboard))}
              navigate(`site-locations/details/${row._id}`);
            }}
          >
            <FiEye />
          </Button>
        </div>
      ),
    },
  ];

  const getDashboardCounter = async (hiddenLoad) => {
    try {
      if (!hiddenLoad) setIsCounterLoading(true);
      // if (userDetails?.role === "superAdmin") {
      const response = await axios.get(endpoint.dashboard_count, {
        withCredentials: true,
        params: { business: JSON.stringify(business), limit: 1000 },
      });
      if (response) {
        setDashboardCounter(response.data.result);
      }
      // }
      if (!hiddenLoad) setIsCounterLoading(false);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };
  const getAlarmCounter = async (filters = {}) => {
    try {
      if (
        (userDetails?.role && userDetails.role !== userRole.superAdmin && !!business.length) ||
        userDetails?.role === userRole.superAdmin
      ) {
        if (Object.keys(filters).length === 0) {
          filters.startDate = dayjs().subtract(7, "day").format("YYYY/MM/DD : HH:mm");
          filters.endDate = dayjs().format("YYYY/MM/DD : HH:mm");
        }
        setStartDate(filters?.startDate);
        setEndDate(filters?.endDate);

        const response = await axios.get(endpoint.dashboard_alarm_count, {
          withCredentials: true,
          params: {
            business,
            ...filters,
          },
        });
        if (response) {
          setAlarmCounter(response.data);
        }
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  useEffect(() => {
    if (search) {
      setLocations("");
      getSiteLocationsWithSensor(search);
    } else if (locations) {
      setSearch("");
      getSiteLocationsWithSensor(locations);
    } else {
      setSiteLocationsWithSensor([]);
    }
  }, [limit, page, business]);

  // handle auto refresh
  useEffect(() => {
    const interval = setInterval(() => {
      getDashboardCounter(true);
      const filter = {};
      if (startDate) filter.startDate = startDate;
      if (endDate) filter.endDate = endDate;
      getAlarmCounter(filter);
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, [startDate, endDate]);

  useEffect(() => {
    document.title = appConfig.name + " - Dashboard";
    getSiteLocations();
    getAlarmCounter();
  }, [business]);

  useEffect(() => {
    getDashboardCounter();
  }, [userDetails, business]);
  // console.log(planDetails);

  const logo = firstBusiness?.logo || "/img/logo.png";
  return (
    <div className="az-content-body p-0 px-md-3">
      <Spin spinning={isCounterLoading}>
        {isFullScreenActive && (
          <img src={logo} alt="" style={{ height: "50px", marginRight: "30px", marginTop: "10px" }} />
        )}
        <div className="my-3 p-0">
          <Row className="g-4" md={5} sm={3} xs={2}>
            {mainCounters?.map(({ entryName, url, roles, ...rest }, idx) => {
              return (
                roles.includes(userDetails?.role) && (
                  <Col key={idx}>
                    <div
                      key={entryName}
                      // style={{
                      //   paddingLeft: idx === 0 ? "0" : "15px",
                      //   paddingRight: idx === 4 ? "0" : "15px",
                      // }}
                    >
                      <Link to={url}>
                        <DashboardCount {...rest} count={dashboardCounter?.[entryName]} />
                      </Link>
                    </div>
                  </Col>
                )
              );
            })}
          </Row>
        </div>

        {/* {(userDetails?.role === userRole?.superAdmin || userDetails?.role === userRole?.admin) && ( */}
        {userDetails?.role !== userRole?.installer && (
          <Row className="mb-4 gy-3">
            <Col md={12} className="d-flex justify-content-between align-items-center">
              <h5 style={{ marginBottom: "-8px" }}>Alarm Summary</h5>
              <AlarmTimeFilter getAlarmCounter={getAlarmCounter} />
            </Col>
            {alarmSummaryCounters?.map(({ entryName, url, ...rest }) => {
              let params = url;
              if (startDate) {
                params = `${url}&startDate=${startDate}&endDate=${endDate}`;
              }
              return (
                <Col md={4} xs={6} key={entryName}>
                  {alarmCounter?.[entryName] === 0 ? (
                    <DashboardCount {...rest} count={alarmCounter?.[entryName]} bg="#E1E1E1" color="#000" />
                  ) : (
                    <Link to={params}>
                      <DashboardCount {...rest} count={alarmCounter?.[entryName]} bg="#E1E1E1" color="#000" />
                    </Link>
                  )}
                </Col>
              );
            })}
          </Row>
        )}
      </Spin>
      <h5 className="pb-2">Advance Search Filters</h5>
      <Form onSubmit={searchHandler}>
        <div className="d-flex flex-sm-row flex-column gap-3">
          <div className="w-100" style={{ maxWidth: 580 }}>
            <Form.Control
              type="search"
              placeholder="Search"
              className="me-2"
              aria-label="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="w-100" style={{ maxWidth: 580 }}>
            <Select
              showSearch={true}
              style={{ width: "100%" }}
              size="large"
              filterOption={(input, option) =>
                (option?.children ? option?.children?.toLowerCase() || "" : "").includes(input?.toLowerCase())
              }
              value={locations || null}
              onChange={(value) => setLocations(value)}
              placeholder="Select Locations"
            >
              {siteLocations?.length > 0 &&
                siteLocations?.map((item) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </div>

          <div className="ms-auto ms-md-0">
            <button type="submit" className="btn bg-secondary-subtle text-black">
              <FaSearch />
            </button>
          </div>
        </div>
      </Form>
      <div className="row row-sm mg-b-15 mg-sm-b-20">
        <div className="col-lg-12 py-5">
          <MapContainer center={mapCenter} zoom={6} scrollWheelZoom={false}>
            <ChangeView center={mapCenter} zoom={6} />
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {siteLocationsWithSensor?.length > 0
              ? siteLocationsWithSensor?.map((site) => (
                  <MapMarker
                    key={site._id}
                    site={site}
                    markerLoading={markerLoading}
                    handleMarkerClick={handleMarkerClick}
                    markerData={markerData}
                  />
                ))
              : siteLocations?.map((site) => (
                  <MapMarker
                    key={site._id}
                    site={site}
                    markerLoading={markerLoading}
                    handleMarkerClick={handleMarkerClick}
                    markerData={markerData}
                  />
                ))}
          </MapContainer>
        </div>
      </div>

      {siteLocationsWithSensor?.length > 0 && (
        <div className="row row-sm mg-b-15 mg-sm-b-20">
          <div className="col-lg-12">
            <div className="card card-dashboard-six">
              <div className="card-header">
                <div>
                  <label className="az-content-label">SEARCH RESULTS</label>
                </div>
              </div>
              <Spin spinning={isLoading}>
                <DataTable
                  columns={columns}
                  dataSource={siteLocationsWithSensor}
                  pagination={{
                    defaultPageSize: limit,
                    current: page,
                    total,
                    showSizeChanger: true,
                    onShowSizeChange: (_, pageSize) => {
                      setLimit(pageSize);
                    },
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                    pageSizeOptions: [10, 20, 50],
                    responsive: true,
                  }}
                  onChange={({ current, pageSize }) => {
                    setLimit(pageSize);
                    setPage(current);
                  }}
                />
              </Spin>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MainDashboard;

MainDashboard.propTypes = {
  isFullScreenActive: PropTypes.bool.isRequired,
};

// eslint-disable-next-line react/prop-types
function ChangeView({ center, zoom }) {
  const map = useMap();
  map.setView(center, zoom);
  return null;
}

let mainCounters = [
  {
    title: "Site Locations",
    // bg: "#2E5A88",
    bg: "var(--dashboard-layout)",
    entryName: "locationCount",
    roles: ["user", "public", "superAdmin", "businessAdmin", "admin"],
    url: "/site-locations",
  },
  {
    title: "All Site Admins",
    // bg: "#FF7F27",
    bg: "var(--dashboard-layout)",
    entryName: "adminCount",
    roles: ["businessAdmin", "superAdmin"],
    url: "/users?role=admin",
  },
  {
    title: "All Site Users",
    // bg: "#cb9418",
    bg: "var(--dashboard-layout)",
    entryName: "userCount",
    roles: ["superAdmin", "businessAdmin", "admin"],
    url: "/users?role=user",
  },
  {
    title: "Devices",
    // bg: "#780078c7",
    bg: "var(--dashboard-layout)",
    entryName: "deviceCount",
    roles: ["user", "public", "superAdmin", "businessAdmin", "admin"],
    url: "/devices",
  },
  {
    title: "Offline Devices",
    // bg: "#f30a0a",
    bg: "var(--dashboard-layout)",
    entryName: "inactiveSensors",
    roles: ["user", "public", "superAdmin", "businessAdmin", "admin"],
    url: "/devices?status=inactive",
  },
];

const alarmSummaryCounters = [
  {
    title: "Total Alarms",
    entryName: "totalAlram",
    url: "/alarm-summary?",
  },
  {
    title: "Total Triggered Alarms",
    entryName: "totalTriggeredAlarm",
    url: "/alarm-history?",
  },
  {
    title: "Total Alarms Acknowledged",
    entryName: "totalAcknoledged",
    url: "/alarm-history?ackow=true",
  },
  // {
  //   title: "Total Alarms Returned to Normal",
  //   entryName: "totalNormal",
  //   url: "/alarm-history?alarm-status=normal",
  // },
];
